export interface ResendSourceRequest {
  id?: number | string;
  vessel_name?: unknown;
  vesselName?: unknown;
  name?: unknown;
  imo_number?: unknown;
  imo?: unknown;
  mmsi?: unknown;
  ssas_number?: unknown;
  terminal_number?: unknown;
  owner_organization?: unknown;
  ship_owner?: unknown;
  contact_person?: unknown;
  contactPerson?: unknown;
  contact_name?: unknown;
  contactName?: unknown;
  contact_phone?: unknown;
  contactPhone?: unknown;
  phone?: unknown;
  contact_email?: unknown;
  contactEmail?: unknown;
  additional_emails?: unknown;
  additionalEmails?: unknown;
}

function toText(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return '';
}

function formatAdditionalEmails(value: unknown): string {
  if (Array.isArray(value)) {
    return value
      .map((item) => toText(item))
      .filter(Boolean)
      .join(', ');
  }
  return toText(value);
}

export function buildRequestResendState(request: ResendSourceRequest) {
  return {
    resendFromRequestId: request.id,
    prefill: {
      vessel_name: toText(request.vessel_name || request.vesselName || request.name),
      imo_number: toText(request.imo_number || request.imo),
      mmsi: toText(request.mmsi),
      ssas_number: toText(request.ssas_number || request.terminal_number),
      owner_organization: toText(request.owner_organization || request.ship_owner),
      contact_person: toText(
        request.contact_person ||
          request.contactPerson ||
          request.contact_name ||
          request.contactName
      ),
      contact_phone: toText(request.contact_phone || request.contactPhone || request.phone),
      contact_email: toText(request.contact_email || request.contactEmail),
      additional_emails: formatAdditionalEmails(
        request.additional_emails ?? request.additionalEmails
      ),
    },
  };
}
